import { render, staticRenderFns } from "./send-button.component.vue?vue&type=template&id=f36f833a&scoped=true"
import script from "./send-button.component.vue?vue&type=script&lang=js"
export * from "./send-button.component.vue?vue&type=script&lang=js"
import style0 from "./send-button.component.vue?vue&type=style&index=0&id=f36f833a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36f833a",
  null
  
)

export default component.exports